import React from 'react';
import { SubvalueCell, Link } from '@backstage/core-components';
import { EntityRefLinks } from '@backstage/plugin-catalog-react';

function customTitle(entity) {
  return entity.metadata.title || entity.metadata.name;
}
const columnFactories = {
  createNameColumn() {
    return {
      title: "Document",
      field: "entity.metadata.name",
      highlight: true,
      render: (row) => /* @__PURE__ */ React.createElement(
        SubvalueCell,
        {
          value: /* @__PURE__ */ React.createElement(Link, { to: row.resolved.docsUrl }, customTitle(row.entity)),
          subvalue: row.entity.metadata.description
        }
      )
    };
  },
  createOwnerColumn() {
    return {
      title: "Owner",
      field: "resolved.ownedByRelationsTitle",
      render: ({ resolved }) => /* @__PURE__ */ React.createElement(
        EntityRefLinks,
        {
          entityRefs: resolved.ownedByRelations,
          defaultKind: "group"
        }
      )
    };
  },
  createKindColumn() {
    return {
      title: "Kind",
      field: "entity.kind"
    };
  },
  createTypeColumn() {
    return {
      title: "Type",
      field: "entity.spec.type"
    };
  }
};

export { columnFactories };
//# sourceMappingURL=columns.esm.js.map
